/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_TeamsInputs */

const en_us2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split into two teams`)
};

const pt_br2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir em dois times`)
};

const es_419_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir en dos equipos`)
};

const pt_pt2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir em duas equipas`)
};

const fr_fr2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Former deux équipes`)
};

const de_de2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In zwei Teams aufteilen`)
};

const it_it2_clubs_field_teams = /** @type {(inputs: Clubs_Field_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi in due squadre`)
};

/**
* | output |
* | --- |
* | "Split into two teams" |
*
* @param {Clubs_Field_TeamsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_teams = /** @type {((inputs?: Clubs_Field_TeamsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_TeamsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_teams(inputs)
	if (locale === "es-419") return es_419_clubs_field_teams(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_teams(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_teams(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_teams(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_teams(inputs)
	return en_us2_clubs_field_teams(inputs)
});
export { clubs_field_teams as "clubs.field_teams" }